
export default {
  selectMySpaceRegularLearns: { // 나의 학습
    method: 'GET',
    url: 'mrm/v1/permit/nrw/mySpace/regularLearns'
  },
  getMyTextPlaceInfo: { // 나의 배송지
    method: 'GET',
    url: 'mrm/v1/student/mySpaceSub/myTextPlaceInfo'
  },
  saveMyTextPlaceInfo: { // 나의 배송지 추가
    method: 'POST',
    url: 'mrm/v1/student/mySpaceSub/myTextPlaceInsert'
  },
  deleteMyTextPlaceInfo: { // 나의 배송지 삭제
    method: 'POST',
    url: 'mrm/v1/student/mySpaceSub/myTextPlaceDelete'
  },
  updateMyTextPlaceInfo: { // 나의 배송지 삭제
    method: 'POST',
    url: 'mrm/v1/student/mySpaceSub/myTextPlaceUpdate'
  },
  confirmMyTextPlaceInfo: { // 나의 교재 배송지 등록
    method: 'POST',
    url: 'mrm/v1/student/mySpaceSub/myTextPlaceConfirm'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/mySpaceApi.js